import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Table,
} from "react-bootstrap";

import { apiWrapper } from "apis/CommonApi";
import * as deviceModelApi from "../apis/DeviceModelApi";
import "./UsersPage.scss";

export default function DeviceModelSettingsPage() {
  const [dataSource, setDataSource] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [deviceDivision, setDeviceDivision] = useState("");
  const [modelName, setModelName] = useState("");
  const [showDialog, setShowDialog] = useState(false);

  const fetchDeviceModels = () => {
    apiWrapper(async () => {
      const { status, data } = await deviceModelApi.getDeviceModels();
      if (status === true) {
        setDataSource(data);
        setSelectedIds([]);
      }
    });
  };

  useEffect(() => {
    fetchDeviceModels();
  }, []);

  const openAddDialog = () => {
    setSelectedItem(null);
    setDeviceDivision("");
    setModelName("");
    setShowDialog(true);
  };

  const openEditDialog = (item) => {
    setSelectedItem(item);
    setDeviceDivision(item.deviceDivision);
    setModelName(item.modelName);
    setShowDialog(true);
  };

  const handleSave = async () => {
    const normalizedCode = deviceDivision.trim().toUpperCase();
    const normalizedName = modelName.trim();

    if (!/^[0-9A-F]{2}-[0-9A-F]{2}$/.test(normalizedCode)) {
      alert("기기 모델 코드는 5E-01 형식으로 입력해주세요.");
      return;
    }
    if (!normalizedName) {
      alert("기기 모델명을 입력해주세요.");
      return;
    }

    const payload = {
      deviceDivision: normalizedCode,
      modelName: normalizedName,
    };

    const result = selectedItem
      ? await deviceModelApi.updateDeviceModel(selectedItem.id, payload)
      : await deviceModelApi.createDeviceModel(payload);

    const { status, data } = result;
    if (status !== true) {
      alert(`저장에 실패했습니다.\n${data}`);
      return;
    }

    alert(selectedItem ? "수정했습니다." : "등록했습니다.");
    setShowDialog(false);
    fetchDeviceModels();
  };

  const handleDelete = async () => {
    if (selectedIds.length === 0) {
      return;
    }
    if (!window.confirm(`${selectedIds.length}개를 삭제하시겠습니까?`)) {
      return;
    }

    const { status, data } = await deviceModelApi.deleteDeviceModels(
      selectedIds
    );
    if (status !== true) {
      alert(`삭제에 실패했습니다.\n${data}`);
      return;
    }

    fetchDeviceModels();
  };

  const handleCheck = (id, checked) => {
    setSelectedIds(
      checked
        ? [...selectedIds, id]
        : selectedIds.filter((selectedId) => selectedId !== id)
    );
  };

  return (
    <div className="print-area">
      <Container fluid className="mb-3 d-flex align-items-center">
        <h1 className="title">기기 모델명 관리</h1>
        <span className="ms-auto">
          <Button className="ms-2" variant="primary" onClick={openAddDialog}>
            추가
          </Button>
          <Button
            className="ms-2"
            variant="danger"
            disabled={selectedIds.length === 0}
            onClick={handleDelete}
          >
            삭제
          </Button>
        </span>
      </Container>

      <Container fluid>
        <p className="text-muted">
          등록되지 않은 코드는 기존 코드값으로 표시됩니다.
          행을 더블클릭하면 수정할 수 있습니다.
        </p>
        <Table bordered hover>
          <thead className="table-header">
            <tr>
              <th style={{ width: "60px" }}></th>
              <th style={{ width: "100px" }}>No</th>
              <th style={{ width: "220px" }}>기기 모델 코드</th>
              <th>기기 모델명</th>
            </tr>
          </thead>
          <tbody className="table-body">
            {dataSource.map((item, index) => (
              <tr
                key={item.id}
                onDoubleClick={() => openEditDialog(item)}
              >
                <td>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedIds.includes(item.id)}
                    onChange={(event) =>
                      handleCheck(item.id, event.target.checked)
                    }
                  />
                </td>
                <td>{index + 1}</td>
                <td>{item.deviceDivision}</td>
                <td>{item.modelName}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>

      <Modal
        show={showDialog}
        onHide={() => setShowDialog(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            기기 모델명 {selectedItem ? "수정" : "추가"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm={4}>
                기기 모델 코드
              </Form.Label>
              <Col>
                <Form.Control
                  value={deviceDivision}
                  placeholder="예: 5E-01"
                  maxLength={5}
                  onChange={(event) =>
                    setDeviceDivision(event.target.value.toUpperCase())
                  }
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column sm={4}>
                기기 모델명
              </Form.Label>
              <Col>
                <Form.Control
                  value={modelName}
                  placeholder="예: WT-LM100S_V1"
                  maxLength={100}
                  onChange={(event) => setModelName(event.target.value)}
                />
              </Col>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDialog(false)}>
            취소
          </Button>
          <Button variant="primary" onClick={handleSave}>
            저장
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
